import {
    useCallback, useMemo, useState,
} from 'react';
import { useGenericAPIMutation } from 'hooks/mutations/useGenericAPIMutation';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { memberIdSelector } from 'redux-store/auth/authSelectors';
import { getClientId } from 'utils';
import useLayoutController from 'components/Stepper/RouteBasedStepper/useLayoutController';
import { PRODUCTS } from 'constants/constants';
import { useCreateProposal } from '../CreateProposalManager';

export const useFinalizeProposal = ({ dfsClientId }) => {
    const { i18n: { language }, t } = useTranslation();

    // const [pageErrors, setPageErrors] = useState<any>(undefined);
    const [isSubmitted, setIsSubmitted] = useState(false);
    const [isSending, setSending] = useState(false);
    const clientId = getClientId(dfsClientId);
    const memberId = useSelector(memberIdSelector);

    const {
        selectedProductTypeSelector,
        selectedProductSelector,
        mainOwner,
        selectedProposalOwner,
        agentInformation,
        selectedLanguage,
        setSelectedLanguageAction,
    } = useCreateProposal();

    const proposals = [
        {
            productGroupType: selectedProductTypeSelector,
            threeBProductName: selectedProductTypeSelector === PRODUCTS.bbb ? selectedProductSelector?.externalId : undefined,
            proposalOwner: selectedProposalOwner?.name || mainOwner?.name,
            advisorName: `${agentInformation?.advisor?.firstName} ${agentInformation?.advisor?.lastName}` || '-',
            agentName: agentInformation?.generalAgency?.name || '-',
        },
    ];

    const { mutateAsync: finalizeMutate } = useGenericAPIMutation();

    const onContinue = useCallback(async () => {
        setIsSubmitted(true);
        setSending(true);
        try {
            await finalizeMutate({
                service: 'customInvestmentService',
                API: 'finalizeProposal',
                payload: [{}],
            });
            setStepComplete(true);
        } catch (err: any) {
            // setPageErrors({
            //     message: err.message || t('general.somethingWentWrong'),
            // });
        } finally {
            setSending(false);
            setIsSubmitted(false);
        }
    }, [language, clientId, memberId, finalizeMutate, t]);

    const languagesOption = useMemo(() => ([
        { label: 'DE', id: 'de' },
        { label: 'FR', id: 'fr' },
        { label: 'IT', id: 'it' },
        { label: 'EN', id: 'en' },
    ]), []);

    const handleSelectLanguage = useCallback((languageId: string) => {
        setSelectedLanguageAction(languagesOption.find(lang => lang.id === languageId));
    }, [setSelectedLanguageAction, languagesOption]);

    const { setStepComplete } = useLayoutController({
        callbackOnContinue: onContinue,
        isContinueDisabled: false,
        isBackDisabled: false,
        reSubscriptionStates: [],
    });

    return {
        t,
        onContinue,
        languagesOption,
        isSubmitted,
        isSending,
        proposals,
        selectedLanguage,
        handleSelectLanguage,
        error: undefined,
    };
};
